export const teacherFields = [
  { name: "همه رشته ها", code: -1 },
  { name: "مهندسی", code: 0 },
  { name: "پزشکی", code: 1 },
  { name: "علوم پایه", code: 2 },
  { name: "طراحی", code: 3 },
  { name: "علوم انسانی", code: 4 },
  { name: "علوم فضایی", code: 5 },
  { name: "علوم دریایی", code: 6 },
  { name: "کشاورزی", code: 8 },
  { name: "مدیریت", code: 9 },
];
export const teacherMajors = [
  { name: "مهندسی", code: 0 },
  { name: "پزشکی", code: 1 },
  { name: "علوم پایه", code: 2 },
  { name: "طراحی", code: 3 },
  { name: "علوم انسانی", code: 4 },
  { name: "علوم فضایی", code: 5 },
  { name: "علوم دریایی", code: 6 },
  { name: "کشاورزی", code: 8 },
  { name: "مدیریت", code: 9 },
];

export const articleFilters = [
  { name: "بیشترین قیمت", code: 0 },
  { name: "کمترین قیمت", code: 1 },
  { name: "جدیدترین", code: 2 },
  { name: "قدیمی ترین", code: 3 },
];
export const donePapersFilters = [
  { name: "بیشترین قیمت", code: 0 },
  { name: "کمترین قیمت", code: 1 },
  { name: "جدیدترین", code: 2 },
  { name: "قدیمی ترین", code: 3 },
];

export const articleFilterCategories = [
  { name: "فنی مهندسی", code: 0 },
  { name: "علوم پزشکی", code: 1 },
  { name: "علوم انسانی", code: 2 },
  { name: "علوم پایه", code: 3 },
  { name: "علوم پایه پزشکی", code: 4 },
  { name: "علوم مدیریتی", code: 5 },
  { name: "هنر و معماری", code: 6 },
];
export const grantDurations = [
  { name: "یک ماه", code: 0 },
  { name: "دو ماه", code: 1 },
  { name: "سه ماه", code: 2 },
  { name: "سایر", code: 3 },
];
export const courseStatuses = [
  { Id: 0, Name: "در انتظار بررسی" },
  { Id: 1, Name: "تایید شده" },
  { Id: 2, Name: "نیاز به بررسی" },
];

export const languages = [
  { name: "فارسی", code: 0 },
  { name: "انگلیسی", code: 1 },
  { name: "فرانسوی", code: 2 },
];

export const paperStatuses = [
  { name: "جدید", code: 0 },
  { name: "تایید شده", code: 1 },
  { name: "پرداخت شده", code: 2 },
  { name: "در انتطار پذیرش", code: 3 },
  { name: "پذیرش شده", code: 4 },
  { name: "انجام شده", code: 5 },
  { name: "تایید شده", code: 6 },
  { name: "نیاز به بررسی", code: 7 },
];
export const ticketManagerStatuses = [
  { name: "جدید", code: 0 },
  { name: "در حال بررسی", code: 1 },
  { name: "پاسخ", code: 2 },
  { name: "پاسخ کاربر", code: 3 },
  { name: "بستن تیکت", code: 4 },
  { name: "نامشخص", code: 5 },
];
export const ticketClientStatuses = [
  { name: "جدید", code: 0 },
  { name: "در حال بررسی", code: 1 },
  { name: "پاسخ پشتیبان", code: 2 },
  { name: "پاسخ", code: 3 },
  { name: "بستن", code: 4 },
  { name: "نامشخص", code: 5 },
];

export const primaryTicketOptions = [
  { name: "مشکل در پرداخت", code: 1 },
  { name: "مالی", code: 2 },
  { name: "علمی", code: 3 },
  { name: "کلاس آنلاین", code: 6 },
  { name: "محصول", code: 4 },
  { name: "سایر", code: 5 },
];
